import Axios from "axios";
import React, { useState, useEffect, useContext, createContext } from "react";
import { Container } from "reactstrap";
import { Table, Button, Typography, Space } from "antd";
import { UserContext } from "../userComponents/UserContext";
import { Link } from "react-router-dom";

const { Title } = Typography;

export const MoviesContext = createContext();

const TableMoviesComponent = (props) => {
  const [, setFilteredInfo] = useState(null);
  const [, setSortedInfo] = useState(null);
  const [movies, setMovies] = useState(null);
  const [user] = useContext(UserContext);

  useEffect(() => {
    if (movies === null) {
      const url = `https://backendexample.sanbersy.com/api/data-movie`;
      Axios.get(url).then((res) => {
        const data = res.data;
        setMovies(data);
        console.log(data);
      });
    }
  }, [movies]);

  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };
  const handleDelete = (e) => {
    const id = e.target.id;
    const url = `https://backendexample.sanbersy.com/api/data-movie/${id}`;
    Axios.delete(url, { headers: { Authorization: `Bearer ${user.token}` } })
      .then((res) => {
        console.log(res);
        setMovies(null);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 200,
      defaultSortOrder: "descend",
      sorter: (a, b) => a.title - b.title,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      tableLayout: "auto",
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      tableLayout: "auto",
    },
    {
      title: "Genre",
      dataIndex: "genre",
      key: "genre",
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      tableLayout: "auto",
    },
    {
      title: "Review",
      dataIndex: "review",
      key: "review",
    },
    {
      title: "Action",
      key: "action",
      render: (e) => (
        <Space size="middle">
          <Link to={`/Edit/Movie/${e.id}`}>
            <Button>Edit</Button>
          </Link>
          <Button id={e.id} onClick={handleDelete} title="Delete">
            Delete
          </Button>
        </Space>
      ),
      width: 200,
    },
  ];
  return (
    <Container className="mt-3 mb-2">
      <Title level={3}>Form Movie</Title>
      <Link to="/fmovies/input">
        <Button type="primary" className="mb-3">
          Input Movie
        </Button>
      </Link>
      <Table columns={columns} dataSource={movies} onChange={handleChange} />
    </Container>
  );
};

export default TableMoviesComponent;
